// extracted by mini-css-extract-plugin
export default {"labelRow":"_dgiflPp","label":"mpe188Vr","infoIcon":"ckETXw8Y","inputWrapper":"GaijK9gW","nicknameDesc":"iQKPi8ql","inputs":"TRUJzKiQ","actions":"_MYfd0Cb","backButton":"uVDuiMOB"};